import React from 'react';
import ajax from 'ajax';

export default class Member extends React.Component
{
    constructor(props) {
        super(props);
        this.state = {
            login: {
                edit: false,
                value: window.User.login,
                error: false,
                node: null
            },
            name: {
                edit: false,
                value: window.User.name,
                error: false,
                node: null
            },
            email: {
                edit: false,
                value: window.User.email,
                error: false,
                node: null
            },
        };

        this.edit = this.edit.bind(this);
        this.blur = this.blur.bind(this);

    }

    edit(scope, e) {
        const s = {...this.state};
        if(s.hasOwnProperty(scope)) {
            s[scope].value = e.target.value;
            s[scope].error = false;
            this.setState(s);
        }
    }

    blur(scope) {
        if(this.state.hasOwnProperty(scope)) {
            let data = {};
            data[scope] = this.state[scope].value;
            ajax.post(
                window.User.saveUrl,
                data,
                (response) => {
                    if(response.toString() !== '1') {
                        const s = {...this.state};
                        s[scope].error = true;
                        this.setState(s);
                    } else {
                        this.setEditable();
                    }
                }
            );
        }

    }

    setEditable(scope) {
        const s = {...this.state};
        for(let i in s) {
            if(s.hasOwnProperty(i)) {
                if(i === scope) {
                    s[i].edit = true;
                    setTimeout(() => {
                        s[i].node.focus();
                    }, 100);
                } else {
                    s[i].edit = false;
                }
            }
        }
        this.setState(s);
    }
    
    render() {

        /*const loginView = this.state.login.edit ?
            <input
                className={"user-info__value" + (this.state.login.error ? ' user-info__value_error' : '')}
                value={this.state.login.value}
                size={this.state.login.value.length || 1}
                onChange={e => this.edit('login', e)}
                onBlur={e => this.blur('login', e)}
            /> :
            <span className="user-info__value">{this.state.login.value}</span>;*/

        const nameView = this.state.name.edit ?
            <input
                className={"user-info__value" + (this.state.name.error ? ' user-info__value_error' : '')}
                value={this.state.name.value}
                size={this.state.name.value.length || 1}
                ref={el => this.state.name.node = el}
                onChange={e => this.edit('name', e)}
                onBlur={e => this.blur('name', e)}
            /> :
            <span className="user-info__value">{this.state.name.value}</span>;

        const mailView = this.state.email.edit?
            <input
                className={"user-info__value" + (this.state.email.error ? ' user-info__value_error' : '')}
                value={this.state.email.value}
                size={this.state.email.value.length || 1}
                ref={el => this.state.email.node = el}
                onChange={e => this.edit('email', e)}
                onBlur={e => this.blur('email', e)}
            /> :
            <span className="user-info__value">{this.state.email.value}</span>;

        return [
            <div className="user-info__item" key="id">
                <span className="user-info__title">ID:</span>{" "}
                <span className="user-info__value user-info__value_readonly">{window.User.id}</span>
            </div>,
            <div className="user-info__item" key="login">
                <span className="user-info__title">LOGIN:</span>{" "}
                <span className="user-info__value user-info__value_readonly">{window.User.login}</span>
            </div>,
            <div className="user-info__item" key="name">
                <span className="user-info__title">NAME:</span>{" "}
                {nameView}{" "}
                <button className="user-info__edit" type="button" onClick={()=>this.setEditable('name')}/>
            </div>,
            <div className="user-info__item" key="mail">
                <span className="user-info__title">MAIL:</span>{" "}
                {mailView}{" "}
                <button className="user-info__edit" type="button" onClick={()=>this.setEditable('email')}/>
            </div>
        ];

        /*
        {<div className="user-info__item" key="login">
                <span className="user-info__title">LOGIN:</span>{" "}
                {loginView}{" "}
                <button className="user-info__edit" type="button" onClick={()=>this.setEditable('login')}/>
            </div>,}
         */
    }

}


// WEBPACK FOOTER //
// ./bundle/component/member.js